import React, { useEffect, useState } from "react";
import moment from "moment";

// En tiempo real el corte lo sella el backend al guardar, así que se muestra la
// hora corriendo y no un valor fijo que quedaría desfasado mientras se revisa
// el formulario. Va aparte para que el tick de cada segundo solo repinte esto
export const RelojCorte = () => {
    const [ahora, setAhora] = useState(moment());

    useEffect(() => {
        const intervalo = setInterval(() => setAhora(moment()), 1000);

        return () => clearInterval(intervalo);
    }, []);

    return (
        <div className="creacion-cierre__reloj">
            <span className="creacion-cierre__reloj-punto" />
            <span className="creacion-cierre__reloj-fecha">
                {ahora.format("DD/MM/YYYY")}
            </span>
            <span className="creacion-cierre__reloj-hora">
                {ahora.format("HH:mm:ss")}
            </span>
        </div>
    );
};
